<template>
    <v-card class="main-card">
        <v-card-title class="primary title white--text">
            {{'Time Series Plots'|translate}}
        </v-card-title>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 fill-height>
                    <div class="leftside">
                        <points-draggable></points-draggable>
                    </div>
                    <div class="rightside">
                        <div class="pa-2">
                            <v-layout row wrap>
                                <v-flex xs4>
                                    <date-range-selector v-model="range"></date-range-selector>
                                </v-flex>
                                <v-flex xs4>
                                    <v-switch color="success"
                                            v-model="onOnly"
                                            :label="'View points when equipment is On'|translate"
                                    ></v-switch>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" class="mr-2"
                                       @click="exportAll()"
                                >
                                    {{'Export charts as PDF'|translate}}
                                </v-btn>
                                <v-btn
                                        color="primary"
                                        @click="newPlotsName=null; dialog=true" v-if="$can('update','CustomViews')"
                                >
                                    <v-icon class="mr-2">fa-save</v-icon>
                                    {{'Save'|translate}}
                                </v-btn>
                                <v-dialog v-model="dialog" max-width="300">
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Save as custom view'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-text-field :label="'Name'|translate" autofocus v-model="newPlotsName" required></v-text-field>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="primary" @click="savePlots" :disabled="!newPlotsName||newPlotsName===''">{{'Save'|translate}}</v-btn>
                                            <v-btn @click="dialog=false">{{'Cancel'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-layout>
                        </div>
                        <plot-and-selector
                                :on-only="onOnly"
                                :date-range="range"
                                ref="selectorplots"
                                v-for="(i,j) in plotCounts"
                                :key="i"
                                v-on:removechart="removeChart(j)"
                        ></plot-and-selector>
                        <v-btn class="accent" @click="addPlot" block large>
                            <v-icon class="mr-2">
                                fa-plus
                            </v-icon>
                            {{'Add Plots'|translate}}
                        </v-btn>
                    </div>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
    import PointsDraggable from '../components/multiplots/PointsDraggable'
    import PlotAndSelector from '../components/multiplots/PlotAndSelector'
    import DateRangeSelector from '../components/DateRangeSelector'
    import exportAllToPDF from "@/components/mixins/exportAllToPDF";
    import moment from 'moment'
    import {uniqueid} from "../helper";

    export default {
        name: 'MultiPlots',
        components: {DateRangeSelector, PlotAndSelector, PointsDraggable},
        mixins:[exportAllToPDF],
        data() {
            return {
                range: null,
                dialog:false,
                onOnly: false,
                newPlotsName:null,
                plotCounts: [1]
            }
        },
        methods: {
            async exportAll() {
                let title = this.$store.state.pointsListStore.pointsList.facility_name + "=" + this.range.start
                this.exportAllItems(this.$refs.selectorplots.map(x=>x.$refs.plot), title);
            },
            addPlot() {
                this.plotCounts.push(uniqueid())
            },
            removeChart(index){
                let plotCounts2=JSON.parse(JSON.stringify(this.plotCounts))
                plotCounts2.splice(index, 1)
                this.plotCounts=plotCounts2
            },
            savePlots() {
                let newConfig=this.getPlotsCofig()
                let me=this
                if(newConfig.length>0){
                    let newPlot={
                        id: uniqueid(),
                        viewType: "plot-list",
                        facility:me.$store.state.pointsListStore.pointsList.facility_name,
                        title: this.newPlotsName,
                        linkTitle: this.newPlotsName,
                        hasOnOnlySwitch: true,
                        plotList: newConfig
                    }
                    this.$store.dispatch('addUserPlot', newPlot).then(function(){
                        me.$store.dispatch('callSnackbar', {text: 'Custom view saved'})
                    })
                }
                this.dialog=false
            },
            getPlotsCofig(){
                let plotConfig = []
                if (this.$refs.selectorplots) {
                    for (let plot of this.$refs.selectorplots) {
                        if (plot.selectedVar && plot.selectedVar.length > 0) {
                            plotConfig.push({
                                id: plot._uid,
                                type:'data3-chart',
                                editDialog:false,
                                config: {
                                    'layout-overrides': {
                                        title:"",
                                        colorway: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                                        xaxis: {
                                            title: "Time"
                                        },
                                        yaxis: {
                                            title: ""
                                        },
                                        zaxis: {
                                            title: null
                                        },
                                        showlegend:true,
                                        height:300,
                                        hovermode:"x",
                                        margin:{
                                            l: 50,
                                            r: 50,
                                            t: 50,
                                            pad: 1
                                        },
                                        legend: {
                                            orientation: 'h',
                                            y: -0.2
                                        },
                                    },
                                    "x-axis":"timestamp",
                                    "y-axis":null,
                                    "color-axis":null,
                                    "color-axis-scale":null,
                                    "color-axis-title":null,
                                    'data-payload': plot.selectedVar.map(function (selectedVar) {
                                        let premap={
                                            'filters': {
                                                equipment_name: selectedVar.equipment_name,
                                                sensor_name: selectedVar.name,
                                            },
                                            seriesOverrides:{
                                                type:'scatter',
                                                opacity:1,
                                                xbins: {
                                                    size: 1
                                                }
                                            },
                                            pipeline:[]
                                        }

                                        return (premap)
                                    }),
                                }
                            })
                        }

                    }
                }
                return plotConfig
            }
        },
        computed: {
            totalPoints() {
                let output = 0
                for (let i in this.$store.state.pointsListStore.pointsList.sensors) {
                    output += this.$store.state.pointsListStore.pointsList.sensors[i].length
                }
                return output
            }
        },
        beforeMount() {
            let maxDate = this.$store.state.pointsListStore.pointsList.data_max_date;
            if (maxDate) {
                this.range = {
                    start: moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),
                    end: moment(maxDate).format('YYYY-MM-DD')
                }
            }
        }
    }
</script>

<style scoped>
    .leftside {
        width: 20%;
        height: 80vh;
        float: left;
        overflow-y: scroll;
    }

    .rightside {
        width: 80%;
        float: right;
        height: 80vh;
        overflow-y: scroll;
    }

    .main-card {
        width: 100%;
    }
</style>
